import React from "react";

const STYLES = {
  High:   "text-emerald-300 bg-emerald-500/15 border-emerald-500/30",
  Medium: "text-amber-300 bg-amber-500/15 border-amber-500/30",
  Low:    "text-zinc-400 bg-zinc-500/15 border-zinc-500/30",
};

/**
 * v2.5C: "Signal quality" — a data-completeness rating for the signal itself,
 * separate from the AI Analyst's qualitative "thesis confidence" and from
 * the "contrarian case strength" on the Contrarian View panel.
 */
export default function ConfidenceBadge({ confidence, testid, className = "" }) {
  if (!confidence) return null;
  const style = STYLES[confidence] || STYLES.Low;
  const tip = "Signal quality — how well-observed this signal is. High = several tracked traders + complete data + strong concentration. Low = few traders, sparse data, or aging signal. This is separate from the AI Analyst's Thesis confidence.";
  return (
    <span
      data-testid={testid || "confidence-badge"}
      title={tip}
      className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-heading uppercase tracking-widest ${style} ${className}`}
    >
      {confidence} quality
    </span>
  );
}
